export default __webpack_public_path__ + "static/media/logo.a36b4f8a.png";